import { AxiosInstance } from 'axios'

interface kmApiGetResponse {
  km: number
}

export class KilometersRoute {
  private baseApi: AxiosInstance
  // private path: string = "Driver";

  constructor(axiosInstance: AxiosInstance) {
    this.baseApi = axiosInstance
  }

  async get(crewId: number | undefined): Promise<kmApiGetResponse> {
    const axiosResponse = await this.baseApi.get(`Kilometers/${crewId}`)
    return axiosResponse.data
  }

  async post(crewId: number, kilometers: number) {
    const axiosResponse = await this.baseApi.post(
      `Kilometers/${crewId}`,
      kilometers,
      { headers: { 'Content-Type': 'application/json' } },
    )
    return axiosResponse.data
  }
}
